import React from 'react';
import { Col, Row } from 'reactstrap';

const PauseLink = ({ t , Nouser}) => {
    
    return (
        <div className='error-color vh-100'>
            <Row className='d-flex justify-content-center align-items-center page1-bg-90vh  m-0'>
                <Col sm={9} xl={5} className='d-flex flex-column justify-content-center align-items-center'>
                    <img src={Nouser} alt='NoDataFound' className='img-fluid pb-5' width={250} />
                    <p className='fw-bold fs-5 m-0 error-color-title'>{t.title}</p>
                    <p className='m-0 pt-0 text-center' style={{ color: "#AAAAAA", whiteSpace: "pre-line" }}>
                        {t.description}
                    </p>
                </Col>
            </Row>
        </div>
    );
};

export default PauseLink;
